<template>
  <b-modal ref="profilesSelector"
           :title="$t('manage.requirements_profiles.open_publics')"
           :ok-title="$t('open')"
           :cancel-title="$t('cancel')"
           size="lg"
           centered
           @ok.prevent="">
    <div>
      <!-- Display -->
      <div class="form-group row">
        <label for="toshow" class="col-md-3 col-form-label text-md-right">{{ $t('display') }}</label>
        <div class="col-md-7">
          <select id="toshow" v-model="category" class="custom-select" name="toshow">
            <option v-for="(cat, i) in categories" :value="i">{{ $t('manage.requirements_profiles.categories.' + cat) }}</option>
          </select>
        </div>
      </div>
      <!-- Search -->
      <div class="form-group row">
        <label for="search" class="col-md-3 col-form-label text-md-right">{{ $t('search') }}</label>
        <div class="input-group col-md-7">
          <div class="input-group-prepend">
            <span class="input-group-text"><fa icon="search" /></span>
          </div>
          <input id="search" :placeholder="$t('search')" v-model="search" type="text" class="form-control" name="search" >
        </div>
      </div>
      <!-- Table -->
      <div class="w-100">
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t('name') }}</th><th>{{ $t('job') }}</th><th>{{ $t('author') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="snapshot in displayedProfiles"
                :class="{ 'bg-light': selected.id == snapshot.id }"
                @click="selected = snapshot">
              <td>{{ snapshot.title }}</td><td>{{ snapshot.accompanying_sheet.job }}</td>
              <td v-if="snapshot.created_by.organization_id == user.organization_id">{{ snapshot.created_by.first_name }} {{ snapshot.created_by.last_name }}</td>
              <td v-else>{{ snapshot.created_by.organizationName }}</td>
            </tr>
          </tbody>
        </table>
        <PaginationBlock v-if="searchFiltered" :page-count-steps="pageCountSteps" :length="searchFiltered.length" v-model="page" />

      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <div class="float-right">
        <b-btn variant="secondary" @click="$refs.profilesSelector.hide()">{{ $t('cancel') }}</b-btn>
        <b-btn variant="primary" @click="openSnapshot">{{ $t('open') }}</b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ProfilesSelector',

  props: {
    profiles: { type: Array, required: true }
  },

  data: () => ({
    categories: ['all', 'organization', 'esap'],
    category: 0,
    search: '',
    selected: -1,
    page: { page: 1, count: 10 },
    pageCountSteps: [10, 25, 50, 100]

  }),

  computed: {
    candidatesProfiles: function () {
      return this.profiles.filter(x => x.accompanying_sheet != null && x.accompanying_sheet.generic_snapshot && x.accompanying_sheet.approved)
    },

    organizationProfiles: function () {
      return this.candidatesProfiles.filter(x => x.created_by.organization_id == this.user.organization_id)
    },

    esapProfiles: function () {
      return this.candidatesProfiles.filter(x => x.accompanying_sheet.shared_with_community && x.created_by.organization_id != this.user.organization_id)
    },

    toShow: function () {
      switch (this.category) {
        case 1: return this.organizationProfiles
        case 2: return this.esapProfiles
        default: return this.candidatesProfiles
      }
    },
    searchFiltered: function () {
      if (this.search.length > 1) {
        let searchTerm = this.search.toLowerCase()
        return this.toShow.filter(x => x.accompanying_sheet.job.toLowerCase().includes(searchTerm) || x.title.toLowerCase().includes(searchTerm))
      }

      return this.toShow
    },
    displayedProfiles () {
      if (this.searchFiltered) {
        const start = (this.page.page - 1) * this.page.count
        const end = start + this.page.count
        return this.searchFiltered.slice(start, end)
      }
      return this.searchFiltered
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: {
    hide () {
      this.$refs.profilesSelector.hide()
    },

    show () {
      this.$refs.profilesSelector.show()
    },

    openSnapshot () {
      if (this.selected) { this.$emit('openSnaphot', this.selected) }
      this.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ProfilesSelector.vue